/**
 * Flag de mantención activo y no vencido (`params/maintenance`). Compartido por
 * la cortina y el indicador de estado del navbar para que no puedan discrepar.
 * Espejo de `src/utils/maintenance.js` del portal de clientes y de
 * `isStateActive` del backend: un cambio de semántica va en los tres.
 *
 * @param {{ active?: boolean, expiresAt?: import('firebase/firestore').Timestamp } | null} maintenance
 * @param {number} [nowMs]
 * @returns {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
export function isMaintenanceActive(maintenance, nowMs = Date.now()) {
  if (maintenance?.active !== true) return false;
  const expiresAtMs = maintenance.expiresAt?.toMillis?.();
  if (typeof expiresAtMs === 'number' && expiresAtMs <= nowMs) return false;
  return true;
}
